import { render, staticRenderFns } from "./IntelligenceFindTalent.vue?vue&type=template&id=22d2d362&scoped=true"
import script from "./IntelligenceFindTalent.vue?vue&type=script&lang=js"
export * from "./IntelligenceFindTalent.vue?vue&type=script&lang=js"
import style0 from "./IntelligenceFindTalent.vue?vue&type=style&index=0&id=22d2d362&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d2d362",
  null
  
)

export default component.exports